import { isConform } from "@/lib/questionDraw";

export function fromDoc(doc) {
  return {
    site_id: doc.site.id,
    task: doc.task || "",
    location: doc.location || "",
    mode: doc.mode || "individuel",
    participants: doc.participants?.length ? doc.participants : [],
    team_id: doc.team_id || null,
    duration_minutes: doc.duration_minutes || null,
    answers: doc.answers || {},
    hazards: doc.hazards || [],
    no_hazard_confirmed: !!doc.no_hazard_confirmed,
    photo_ids: doc.photo_ids || [],
  };
}

export function validateTake5(doc, d) {
  const e = {};
  if (!d.task.trim()) e.task = "Décrivez la tâche à réaliser.";
  if (!d.location.trim()) e.location = "Précisez le lieu de l'intervention.";
  if (d.mode === "collectif" && !d.participants.filter((p) => (typeof p === "string" ? p.trim() : p.name)).length)
    e.participants = "Indiquez au moins un participant pour un Take 5 collectif.";
  if (!d.duration_minutes) e.duration_minutes = "Choisissez la durée prévue.";
  else if (new Date(doc.start_at).getTime() + d.duration_minutes * 60000 <= Date.now())
    e.duration_minutes = "La durée choisie est déjà écoulée depuis le début du Take 5. Choisissez une durée plus longue ou arrêtez le travail.";
  doc.questions.forEach((q) => {
    const a = d.answers[q.id];
    if (!a) e[`answers.${q.id}`] = "Répondez à cette question.";
    else if (!isConform(q, a)) e[`answers.${q.id}`] = "Réponse non conforme : la tâche ne peut pas être autorisée.";
  });
  if (!d.hazards.length && !d.no_hazard_confirmed)
    e.hazards = "Sélectionnez les dangers ou confirmez qu'aucun danger n'a été identifié.";
  if (d.hazards.length && d.no_hazard_confirmed)
    e.no_hazard_confirmed = "Vous avez sélectionné des dangers : retirez la confirmation « aucun danger ».";
  d.hazards.forEach((h) => {
    if (!h.label.trim()) e[`hazards.${h.key}`] = "Décrivez ce danger.";
    else if (!h.measures.length) e[`hazards.${h.key}`] = "Ajoutez au moins une mesure de maîtrise.";
    else if (h.measures.some((m) => !m.trim())) e[`hazards.${h.key}`] = "Chaque mesure de maîtrise doit contenir du texte.";
  });
  return e;
}

export const DECISION_LABEL = { autorisee: "Tâche autorisée", arretee: "Travail arrêté", terminee: "Tâche terminée" };
